import { DataURL, responseCheck, notifyHelper, authHeader, downloadblob } from './index'
import instance from './http'
export async function RequestLink(id) {
    instance
        .get(DataURL + "Export?Id=" + id, {
            headers: authHeader()
        })
        .then((response) => {
            var res = response.data;
            if (res.email) {
                notifyHelper("success", "Request created! You will receive an email regarding your request!");
            }
            else {
                instance
                    .get(DataURL + "downloadFile?fname=" + res.filename, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(res.filename, response.data, res.type);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            }
        })
        .catch(function (error) {
            responseCheck(error.response.status);
        })
}